import React from 'react';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import Load from 'components/Load';
import basePath from 'utils/basePath';
import { isCordova } from 'utils/platform';

const AsyncHostHomePageContainer = Load(() => import(/* webpackChunkName: "host-homescreen" */'./containers/HostHomePageContainer'));
const AsyncFeedbackContainer = Load(() => import(/* webpackChunkName: "host-homescreen" */'./containers/FeedbackContainer'));
const AsyncHostDashboardContainer = Load(() => import(/* webpackChunkName: "host-homescreen" */'./containers/HostDashboardContainer'));

const hostHomePageRoute = [
  (
    <NavigationableLayout
      key="host-homepage"
      path={`${basePath}/host/home`}
      hideFooter
      component={AsyncHostHomePageContainer}
      showBottomNavigation
      noNavbar={isCordova()}
      nonFixedNavbar
    />
  ),
  (
    <NavigationableLayout
      key="host-feedback"
      path={`${basePath}/host/feedback`}
      hideFooter
      component={AsyncFeedbackContainer}
      showBottomNavigation
      noNavbar={isCordova()}
      nonFixedNavbar
    />
  ),
  (
    <NavigationableLayout
      key="host-dashboard"
      path={`${basePath}/host/dashboard`}
      hideFooter
      component={AsyncHostDashboardContainer}
      showBottomNavigation
      noNavbar={isCordova()}
      nonFixedNavbar
    />
  ),
];

export default hostHomePageRoute;
